<div class="form-inline">
  <nb-form-field fullWidth>
    <input
      type="text"
      nbInput
      fullWidth
      shape="semi-round"
      class="form-control"
      placeholder="Nhập để tìm kiếm"
      [(ngModel)]="strSearch"
      (change)="onSearch()"
    />
    <button
      nbSuffix
      nbButton
      ghost
      shape="semi-round"
      nbTooltip="Tra cứu"
      (click)="search()"
    >
      <nb-icon icon="search-outline"> </nb-icon>
    </button>
  </nb-form-field>

  <button
    *ngIf="userService.$isAuthenticated | async"
    type="submit"
    nbButton
    outline
    shape="semi-round"
    status="primary"
    size="small"
    (click)="newCourse()"
    [disabled]="loading"
    [class.btn-pulse]="loading"
  >
    Tạo mới
  </button>
</div>

<div class="row" [nbSpinner]="loading" nbSpinnerStatus="info">
  <div
    *ngFor="let course of displayCourses; let i = index"
    class="col-xxxl-3 col-xxl-3 col-lg-3 col-md-6"
  >
    <ngx-view-course [course]="course" [mode]="'course'"></ngx-view-course>
  </div>
</div>

<button
  *ngIf="(cloud && !done) || (!cloud && courses.length < pagination.count)"
  (click)="loadMore()"
  nbButton
  ghost
  status="info"
  [disabled]="loading"
  [class.btn-pulse]="loading"
>
  <nb-icon class="action-icon" icon="more-horizontal-outline"></nb-icon>
  Xem thêm
</button>
